import { Controller } from "@hotwired/stimulus"

// Toggles the manager list filter. On desktop the panel is an inline card; on
// mobile CSS turns the open panel into a modal overlay (see manager/lists.scss).
// While the panel is closed, the summary of active filters stays visible.
export default class extends Controller {
    static targets = ["panel", "summary"]

    connect() {
        this.close()
    }

    toggle() {
        this.element.classList.contains("is-open") ? this.close() : this.open()
    }

    open() {
        this.panelTarget.hidden = false
        if (this.hasSummaryTarget) this.summaryTarget.hidden = true
        this.element.classList.add("is-open")
        document.body.classList.add("mng-filter-open")
    }

    close() {
        this.panelTarget.hidden = true
        if (this.hasSummaryTarget) this.summaryTarget.hidden = false
        this.element.classList.remove("is-open")
        document.body.classList.remove("mng-filter-open")
    }

    // Close when the mobile backdrop (the panel element itself, around the card)
    // is clicked.
    backdrop(event) {
        if (event.target === this.panelTarget) this.close()
    }

    // Close on Escape.
    keydown(event) {
        if (event.key === "Escape") this.close()
    }
}
